import axios from "axios";
import { requiredParam } from "@utils/func";

const getRenewal = ({ renewalId = requiredParam("renewalId") } = {}) => {
  return axios.get(`renewals/${renewalId}`);
};

const patchRenewal = ({
  renewalId = requiredParam("renewalId"),
  data = requiredParam("data"),
} = {}) => {
  return axios.patch(`renewals/${renewalId}`, data);
};

const getCompanyRenewals = ({
  companyId = requiredParam("companyId"),
} = {}) => {
  return axios.get(`companies/${companyId}/renewals/with-invoice`);
};

export { getRenewal, getCompanyRenewals, patchRenewal };
